// @ts-nocheck
import { mixins } from 'sonata-react-components';
import styled from 'styled-components';

export const ReportingDownloadHeaderStyle = styled.div`
  background-color: ${props => props.theme.bgColor};
  width: 100%;
  z-index: 3;
  border-bottom: 1px solid ${props => props.theme.grayUltraUltraLight};
  position: fixed;
  top: 50px;

  .header {
    position: sticky;
  }

  .reportingHeader {
    &__backLink {
      display: flex;
      align-items: center;
      height: 32px;
      padding-right: 1rem;
      i {
        color: ${props => props.theme.uiColors?.headerIcon};
        font-size: 18px;
        font-weight: 400;
        height: 15.82px;
        width: 16px;
        cursor: pointer;
      }
    }

    &__reset {
      padding: 0 16px;
      border-right: solid 1px ${props => props.theme.uiColors?.headerSeparator};
    }

    &__save {
      padding: 0;
    }

    &__menu {
      display: inline-flex;
      flex-direction: column;
      padding: 8px 0;
      max-height: 200px;
      overflow-y: scroll;
      ${mixins.forceScrollbar};

      &Template {
        display: inline-flex;
        text-wrap: nowrap;
        font-size: ${props => props.theme.fontSizeS};
        color: ${props => props.theme.uiColors?.templateTextColor};
        min-height: 27px;
        padding: 4px 16px;
        cursor: pointer;

        &Name {
          max-width: 260px;
          overflow:hidden;
          white-space:nowrap;
          text-overflow: ellipsis;
        }

        &:hover {
          background-color: ${props => props.theme.uiColors?.templateItemBackground};
        }
      }

      &Sheet {
        padding-left: 5px;
        font-size: ${props => props.theme.fontSizeXS};
        color: ${props => props.theme.uiColors?.templateDescriptionColor};
      }

      &Button {
        justify-content: end;
        padding: 0 8px;
      }
    }

    &__template {
      display: inline-flex;
      flex-direction: row;
      padding: 8px;
      gap: 8px;

      .customInputContainer {
        margin-top: 0;
      }
    }
  }
`;
